import { Skeleton } from '@mui/material';

export const InfoTabSkeleton = () => {
    return (
        <div className='overflow-hidden rounded-lg border border-solid border-N200'>
            <div className='flex items-start gap-2.5 border-b border-solid border-N100 p-3 sm:p-4'>
                <Skeleton variant='rounded' width={36} height={36} className='rounded-lg' />
                <div className='flex-1'>
                    <Skeleton variant='text' width={96} height={18} />
                    <Skeleton variant='text' width='90%' height={18} />
                </div>
            </div>
            <Skeleton variant='rounded' className='h-44 w-full rounded-none sm:h-52 md:h-60' />
        </div>
    );
};
